import { PromoAnalyticsService } from '@analytics/feature';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BannerOneRowItem } from '@promo/const';
import { PromoService } from '@promo/data-access';
import { InViewportDirective, SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { DeviceService } from '@shared/services';
import { combineLatest, filter, map, Observable } from 'rxjs';

// TODO: костыль для HP-55
const OVERRIDE_IMG_LINK = 'https://sdvor-e-commerce-prod-strapi.storage.yandexcloud.net/K_Cz_e4ffa16932.jpg';

@Component({
  selector: 'sd-banner-one-row',
  imports: [CommonModule, NgOptimizedImage, SdvorGenericLinkComponent, InViewportDirective],
  templateUrl: './banner-one-row.component.html',
  styleUrls: ['./banner-one-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerOneRowComponent implements OnInit {
  isTabletUp$: Observable<boolean> = this.deviceService.isTabletMdUp$;
  isDesktopUp$: Observable<boolean> = this.deviceService.isDesktopLgUp$;
  isLoading$: Observable<boolean> = this.promoService.getPromoLoading();

  bannerOneRows$: Observable<BannerOneRowItem[]>;
  numberOfSkeletons$ = this.isTabletUp$.pipe(map((isTabletUp) => (isTabletUp ? 3 : 4)));

  constructor(
    public deviceService: DeviceService,
    private promoService: PromoService,
    private promoAnalyticsService: PromoAnalyticsService,
  ) {}

  ngOnInit(): void {
    const isSdvorApp = this.deviceService.isSdvorApp();
    this.bannerOneRows$ = combineLatest({
      promo: this.promoService.getPromo().pipe(filter((promo) => !!promo)),
      isTabletUp: this.isTabletUp$,
      isDesktopUp: this.isDesktopUp$,
    }).pipe(
      map(({ promo, isTabletUp, isDesktopUp }) => {
        const filteredBannerRows = promo.bannerOneRows
          ? isTabletUp
            ? promo.bannerOneRows.slice(0, 3)
            : promo.bannerOneRows
          : [];

        return filteredBannerRows.map((banner) => {
          let { url } = banner;

          // TODO: костыль для HP-55
          if (isSdvorApp) {
            if (banner.link.toLowerCase() === '/prilozhenie-stroitelnyj-dvor') {
              banner.link = '/kontakt-centr';
              url = {
                isDesktop: OVERRIDE_IMG_LINK,
                isMobile: OVERRIDE_IMG_LINK,
                isTablet: OVERRIDE_IMG_LINK,
              };
            }
          }

          return {
            ...banner,
            url: isDesktopUp ? url.isDesktop : isTabletUp ? url.isTablet : url.isMobile,
          };
        });
      }),
    );
  }

  protected onBannerIntersect(banner: BannerOneRowItem): void {
    const { id, name } = banner;
    this.promoAnalyticsService.onShowBanner({
      id,
      name: name,
      position: 'main_page',
    });
  }

  protected onBannerClick(banner: BannerOneRowItem): void {
    const { id, name } = banner;
    this.promoAnalyticsService.onClickBanner({
      id,
      name: name,
      position: 'main_page',
    });
  }
}
